module.exports = __webpack_public_path__ + "img/Email.93360a3c.svg";